__turbopack_context__.v({
  "bandBody": "inU20a_bandBody",
  "body": "inU20a_body",
  "cardBody": "inU20a_cardBody",
  "cardTitle": "inU20a_cardTitle",
  "container": "inU20a_container",
  "ctaText": "inU20a_ctaText",
  "display": "inU20a_display",
  "eyebrow": "inU20a_eyebrow",
  "faqAnswer": "inU20a_faqAnswer",
  "faqQuestion": "inU20a_faqQuestion",
  "geist": "inU20a_geist",
  "heading": "inU20a_heading",
  "itemTitle": "inU20a_itemTitle",
  "lead": "inU20a_lead",
  "legal": "inU20a_legal",
  "listTitle": "inU20a_listTitle",
  "monoButton": "inU20a_monoButton",
  "monoMeta": "inU20a_monoMeta",
  "pill": "inU20a_pill",
  "pillLinedOnDark": "inU20a_pillLinedOnDark" + " " + "inU20a_pill",
  "pillSolidOnDark": "inU20a_pillSolidOnDark" + " " + "inU20a_pill",
  "primaryPill": "inU20a_primaryPill" + " " + "inU20a_ctaText",
  "smallButton": "inU20a_smallButton" + " " + "inU20a_pill",
  "subtitle": "inU20a_subtitle" + " " + "inU20a_body",
  "title": "inU20a_title" + " " + "inU20a_heading",
});
